import { AnchorDirectiveModule, FormsDirectiveModule, SpinnerDirectiveModule } from '@b2b/common/directives';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { AuthInterceptorFactoryModule } from './common/factories/authentication-interceptor/authentication-interceptor.factory';
import { ConflictInterceptorFactoryModule } from './common/factories/conflictInterceptor/conflictInterceptor.factory';
import { PermissionsInterceptorFactoryModule } from './common/factories/permissionsInterceptor/permissionsInterceptor.factory';
import { CustomerFeesApiServiceModule } from './common/services/api/customerFeesApi/customerFeesApi.service';
import { RateCardsApiServiceModule } from './common/services/api/rateCardsApi/rateCardsApi.service';
import { AuthenticationServiceModule } from './common/services/auth/authentication.service';
import { BugsnagServiceModule } from './common/services/bugsnag';
import { FeatureServiceModule } from './common/services/feature/feature.service';
import { NavigationServiceModule } from './common/services/navigation/navigation.service';
import { PendoServiceModule } from './common/services/pendo';
import { ApplicationView } from './views/application/application';
import { AuthView } from './views/auth/auth';
import { ChangePasswordView } from './views/changePassword/changePassword';
import { HomeView } from './views/home/home';
import { LoginView } from './views/login/login';
import { LogoutView } from './views/logout/logout';
import { OnboardView } from './views/onboard/onboard';
import { RecoverPasswordView } from './views/recoverPassword/recoverPassword';
import { ResetPasswordView } from './views/resetPassword/resetPassword';
import { ZendeskLoginView } from './views/zendeskLogin/zendeskLogin';
import { ZendeskLogoutView } from './views/zendeskLogout/zendeskLogout';

export default angular.module('acme', [
  uiRouter,
  'ui.bootstrap',
  'ui.scrollfix',
  'angular-growl',
  'ui.sortable',
  'ngAria',
  'ngSanitize',
  'LocalStorageModule',
  'ng.shims.placeholder',
  'pascalprecht.translate',
  'acme.templates.app',
  ApplicationView,
  RecoverPasswordView,
  ResetPasswordView,
  ChangePasswordView,
  HomeView,
  OnboardView,
  AuthView,
  LoginView,
  ZendeskLoginView,
  ZendeskLogoutView,
  LogoutView,
  PermissionsInterceptorFactoryModule,
  'acme.common.controller.permissionsInterceptor',
  ConflictInterceptorFactoryModule,
  'acme.common.controller.conflictInterceptor',
  AuthInterceptorFactoryModule,
  'acme.common.service.auth',
  AuthenticationServiceModule,
  'acme.common.service.config',
  CustomerFeesApiServiceModule,
  RateCardsApiServiceModule,
  NavigationServiceModule,
  FeatureServiceModule,
  'acme.common.service.featureToggle',
  'acme.common.service.permissions',
  'acme.common.service.logger',
  'acme.common.service.tenant',
  BugsnagServiceModule,
  PendoServiceModule,
  AnchorDirectiveModule,
  FormsDirectiveModule,
  SpinnerDirectiveModule,
  'jsonFormatter',
]);
